var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep1Grafik(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 358,
    height: 346.273,
    viewBox: "0 0 358 346.273",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rechteck_62",
    x: 201,
    y: 153,
    width: 106,
    height: 87,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#57b0b6",
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Maske",
    d: "M2,0H74a2,2,0,0,1,2,2V57a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z",
    transform: "translate(-0.16 0.098)",
    fill: "#fff",
    stroke: "#ebeeeb",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    x2: 0,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d6edf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_51",
    "data-name": "Pfad 51",
    d: "M37.762,56.863c-12.587.173-25.175.346-37.762,0v.348H75.521v-.348c-5.319-.146-10.639-.2-15.958-.2-7.267,0-14.534.1-21.8.2m0-1.161c-12.587.735-25.173,1.469-37.76,0v.348c12.587,1.137,25.174.568,37.76,0s25.174-1.137,37.761,0V55.7a137.455,137.455,0,0,0-15.96-.848c-7.268,0-14.533.424-21.8.848m0-1.16c-12.587,1.272-25.173,2.545-37.76,0v.348c12.587,2.227,25.174,1.113,37.76,0s25.174-2.227,37.761,0v-.348a80.157,80.157,0,0,0-15.96-1.469,217.229,217.229,0,0,0-21.8,1.469m0-1.16c-12.587,1.787-25.174,3.574-37.76,0v.348c12.587,3.27,25.174,1.635,37.76,0s25.174-3.27,37.761,0v-.348a57.916,57.916,0,0,0-15.959-2.063c-7.268,0-14.534,1.032-21.8,2.063m0-1.16C25.174,54.5,12.587,56.777,0,52.222v.348c12.587,4.265,25.173,2.133,37.76,0s25.174-4.265,37.761,0v-.348a46.262,46.262,0,0,0-15.959-2.63c-7.268,0-14.534,1.315-21.8,2.63m0-1.161c-12.587,2.745-25.174,5.49-37.761,0v.349c12.587,5.214,25.174,2.607,37.76,0s25.174-5.214,37.761,0v-.349a39.194,39.194,0,0,0-15.959-3.169c-7.268,0-14.534,1.585-21.8,3.169m0-1.16C25.174,53.089,12.587,56.277,0,49.9v.349c12.587,6.115,25.174,3.058,37.76,0s25.174-6.115,37.761,0V49.9a34.521,34.521,0,0,0-15.959-3.682c-7.268,0-14.534,1.841-21.8,3.682m0-1.16c-12.587,3.609-25.174,7.217-37.76,0v.349c12.587,6.97,25.174,3.485,37.76,0s25.174-6.97,37.761,0V48.74a31.249,31.249,0,0,0-15.959-4.167c-7.268,0-14.534,2.083-21.8,4.167m0-1.16C25.174,51.585,12.587,55.59,0,47.579v.348c12.587,7.777,25.174,3.889,37.76,0s25.174-7.777,37.761,0v-.348a28.866,28.866,0,0,0-15.959-4.625c-7.268,0-14.534,2.312-21.8,4.625m0-1.161C25.174,50.8,12.587,55.176,0,46.419v.348c12.587,8.538,25.174,4.269,37.76,0s25.174-8.538,37.761,0v-.348a27.081,27.081,0,0,0-15.96-5.056c-7.268,0-14.533,2.528-21.8,5.056m0-1.16c-12.587,4.728-25.174,9.456-37.76,0v.348c12.587,9.251,25.174,4.625,37.76,0s25.174-9.251,37.761,0v-.348A25.714,25.714,0,0,0,59.561,39.8c-7.268,0-14.533,2.73-21.8,5.459m0-1.16C25.174,49.152,12.587,54.206,0,44.1v.348c12.587,9.917,25.174,4.959,37.76,0s25.174-9.917,37.761,0V44.1a24.652,24.652,0,0,0-15.959-5.836c-7.268,0-14.534,2.918-21.8,5.836m0-1.161C25.174,48.294,12.587,53.65,0,42.937v.348c12.587,10.536,25.174,5.268,37.76,0s25.174-10.536,37.76,0v-.348a23.815,23.815,0,0,0-15.959-6.185c-7.268,0-14.533,3.092-21.8,6.185m0-1.16c-12.587,5.635-25.174,11.271-37.76,0v.348c12.587,11.108,25.174,5.554,37.76,0s25.174-11.108,37.761,0v-.348C70.2,37.014,64.881,35.27,59.561,35.27c-7.268,0-14.533,3.253-21.8,6.507m0-1.16C25.174,46.507,12.587,52.4,0,40.616v.348c12.587,11.633,25.174,5.817,37.76,0s25.174-11.633,37.761,0v-.348c-5.319-4.979-10.64-6.8-15.959-6.8-7.268,0-14.533,3.4-21.8,6.8m0-1.16C25.174,45.579,12.587,51.7,0,39.456V39.8c12.587,12.111,25.174,6.056,37.76,0s25.174-12.111,37.761,0v-.348c-5.319-5.175-10.64-7.069-15.959-7.07-7.268,0-14.534,3.535-21.8,7.07m0-1.161C25.174,44.627,12.587,50.958,0,38.3v.348c12.587,12.542,25.174,6.271,37.76,0s25.174-12.542,37.761,0V38.3c-5.319-5.351-10.64-7.31-15.959-7.31-7.268,0-14.534,3.655-21.8,7.31m0-1.16c-12.587,6.516-25.174,13.032-37.76,0v.348c12.587,12.926,25.174,6.463,37.76,0s25.174-12.926,37.761,0v-.348c-5.319-5.507-10.64-7.523-15.96-7.524-7.268,0-14.533,3.762-21.8,7.524m0-1.16c-12.587,6.677-25.174,13.354-37.76,0v.348c12.587,13.262,25.174,6.631,37.76,0s25.174-13.262,37.761,0v-.348c-5.319-5.643-10.64-7.71-15.959-7.71-7.268,0-14.533,3.855-21.8,7.71m0-1.16c-12.587,6.815-25.174,13.629-37.76,0v.348c12.587,13.552,25.174,6.776,37.76,0s25.174-13.552,37.761,0v-.348c-5.319-5.76-10.64-7.869-15.959-7.869-7.268,0-14.533,3.934-21.8,7.869m0-1.161c-12.587,6.929-25.174,13.858-37.76,0V34C12.587,47.8,25.174,40.9,37.76,34s25.174-13.794,37.761,0v-.348c-5.319-5.856-10.64-8-15.959-8-7.268,0-14.533,4-21.8,8m0-1.16c-12.587,7.02-25.174,14.039-37.76,0v.348c12.587,13.99,25.174,6.995,37.76,0s25.174-13.99,37.761,0v-.348c-5.319-5.933-10.64-8.1-15.959-8.105-7.268,0-14.533,4.052-21.8,8.105m0-1.16c-12.587,7.087-25.174,14.173-37.76,0v.348c12.587,14.138,25.174,7.069,37.76,0s25.174-14.138,37.761,0v-.348c-5.319-5.99-10.64-8.182-15.959-8.183-7.268,0-14.534,4.091-21.8,8.183m0-1.161c-12.587,7.13-25.174,14.26-37.76,0v.349c12.587,14.239,25.174,7.12,37.76,0s25.174-14.239,37.761,0v-.349c-5.319-6.026-10.64-8.233-15.959-8.233-7.268,0-14.534,4.116-21.8,8.233m0-1.16c-12.587,7.15-25.174,14.3-37.76,0v.349c12.587,14.293,25.174,7.147,37.76,0s25.174-14.293,37.761,0v-.349c-5.319-6.043-10.64-8.256-15.959-8.256-7.268,0-14.534,4.128-21.8,8.256m0-1.16C25.174,35,12.587,42.144,0,27.851V28.2c12.587,14.3,25.174,7.15,37.76,0s25.174-14.3,37.761,0v-.348C70.2,21.811,64.881,19.6,59.562,19.6c-7.268,0-14.534,4.126-21.8,8.252m0-1.161C25.174,33.81,12.587,40.93,0,26.69v.348c12.587,14.26,25.174,7.13,37.76,0s25.174-14.26,37.76,0V26.69C70.2,20.673,64.881,18.47,59.561,18.47c-7.268,0-14.533,4.11-21.8,8.221m0-1.161C25.174,32.6,12.587,39.668,0,25.53v.348c12.587,14.173,25.174,7.087,37.76,0s25.174-14.173,37.761,0V25.53c-5.319-5.975-10.64-8.162-15.96-8.163-7.268,0-14.533,4.081-21.8,8.163m0-1.16c-12.587,6.995-25.174,13.99-37.76,0v.349c12.587,14.039,25.174,7.02,37.76,0s25.174-14.039,37.761,0v-.349c-5.319-5.912-10.64-8.076-15.959-8.077-7.268,0-14.534,4.038-21.8,8.077m0-1.16C25.174,30.106,12.587,37,0,23.209v.348c12.587,13.858,25.174,6.929,37.76,0s25.174-13.858,37.761,0v-.348c-5.319-5.83-10.64-7.964-15.96-7.964-7.268,0-14.533,3.982-21.8,7.964m0-1.16C25.174,28.824,12.587,35.6,0,22.048V22.4c12.587,13.629,25.174,6.815,37.76,0s25.174-13.629,37.761,0v-.348c-5.319-5.727-10.64-7.824-15.959-7.824-7.268,0-14.533,3.912-21.8,7.824m0-1.161C25.174,27.519,12.587,34.15,0,20.888v.348c12.587,13.354,25.174,6.677,37.76,0s25.174-13.354,37.761,0v-.348c-5.319-5.6-10.64-7.657-15.959-7.657-7.268,0-14.533,3.828-21.8,7.657m0-1.16C25.174,26.19,12.587,32.653,0,19.727v.348c12.587,13.032,25.174,6.516,37.76,0s25.174-13.032,37.761,0v-.348c-5.319-5.462-10.64-7.462-15.959-7.463-7.268,0-14.533,3.731-21.8,7.463m0-1.16c-12.587,6.271-25.174,12.542-37.76,0v.348c12.587,12.662,25.174,6.331,37.76,0s25.174-12.662,37.761,0v-.348c-5.319-5.3-10.64-7.241-15.959-7.241-7.268,0-14.533,3.62-21.8,7.241m0-1.161c-12.587,6.056-25.174,12.111-37.76,0v.348c12.587,12.245,25.174,6.123,37.76,0s25.174-12.245,37.76,0v-.348c-5.319-5.118-10.64-6.992-15.959-6.992-7.268,0-14.533,3.5-21.8,6.992m0-1.16c-12.587,5.817-25.174,11.633-37.76,0v.348c12.587,11.782,25.174,5.891,37.76,0s25.174-11.782,37.761,0v-.348C70.2,11.33,64.881,9.53,59.561,9.53c-7.268,0-14.533,3.358-21.8,6.716m0-1.161C25.174,20.64,12.587,26.194,0,15.085v.348c12.587,11.271,25.174,5.635,37.76,0s25.174-11.271,37.761,0v-.348C70.2,10.391,64.881,8.672,59.562,8.672c-7.268,0-14.534,3.206-21.8,6.413m0-1.16c-12.587,5.268-25.174,10.536-37.76,0v.348c12.587,10.713,25.174,5.356,37.76,0s25.174-10.713,37.761,0v-.348A24.046,24.046,0,0,0,59.561,7.842c-7.268,0-14.534,3.041-21.8,6.083m0-1.161c-12.587,4.959-25.174,9.917-37.76,0v.348c12.587,10.108,25.174,5.054,37.76,0S62.934,3,75.521,13.113v-.348A24.944,24.944,0,0,0,59.562,7.039c-7.268,0-14.534,2.863-21.8,5.726m0-1.161C25.174,16.23,12.587,20.855,0,11.6v.348c12.587,9.456,25.174,4.728,37.76,0s25.174-9.456,37.761,0V11.6A26.088,26.088,0,0,0,59.562,6.263c-7.268,0-14.534,2.67-21.8,5.341m0-1.16c-12.587,4.269-25.174,8.538-37.76,0v.348c12.587,8.757,25.174,4.379,37.76,0s25.174-8.757,37.76,0v-.348A27.567,27.567,0,0,0,59.561,5.514c-7.268,0-14.534,2.464-21.8,4.929m0-1.16C25.174,13.172,12.587,17.06,0,9.283v.348c12.587,8.011,25.174,4.005,37.76,0s25.174-8.011,37.76,0V9.283a29.508,29.508,0,0,0-15.959-4.49c-7.268,0-14.534,2.245-21.8,4.49m0-1.16c-12.587,3.485-25.174,6.97-37.76,0v.348c12.587,7.217,25.174,3.609,37.76,0s25.174-7.217,37.761,0V8.123A32.12,32.12,0,0,0,59.561,4.1c-7.268,0-14.533,2.012-21.8,4.024m0-1.161C25.173,10.02,12.587,13.078,0,6.962V7.31c12.587,6.377,25.174,3.189,37.76,0s25.174-6.377,37.761,0V6.962a35.745,35.745,0,0,0-15.96-3.531c-7.268,0-14.533,1.765-21.8,3.531m0-1.161C25.174,8.409,12.587,11.015,0,5.8V6.15c12.587,5.49,25.174,2.745,37.76,0s25.174-5.49,37.761,0V5.8a41,41,0,0,0-15.959-3.01c-7.268,0-14.533,1.505-21.8,3.01m0-1.16C25.174,6.774,12.587,8.906,0,4.641v.348c12.587,4.555,25.174,2.278,37.76,0s25.174-4.555,37.761,0V4.641A49.12,49.12,0,0,0,59.562,2.178c-7.268,0-14.534,1.231-21.8,2.463m0-1.16C25.174,5.115,12.587,6.75,0,3.481v.348c12.587,3.574,25.174,1.787,37.76,0s25.174-3.574,37.761,0V3.481A63,63,0,0,0,59.562,1.593a169.884,169.884,0,0,0-21.8,1.888m0-1.161C25.174,3.433,12.587,4.547,0,2.32v.349c12.587,2.545,25.174,1.272,37.76,0s25.174-2.545,37.761,0V2.32A91.285,91.285,0,0,0,59.562,1.034c-7.268,0-14.534.643-21.8,1.286m0-1.16C25.174,1.728,12.587,2.3,0,1.159v.349c12.587,1.469,25.174.735,37.76,0s25.174-1.469,37.761,0V1.159C70.2.679,64.881.5,59.562.5c-7.267,0-14.534.328-21.8.656M0,0V.347c12.587.346,25.174.173,37.762,0S62.935,0,75.521.347V0Z",
    transform: "translate(0 0.001)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.76,
    y1: 0.055,
    x2: 0.242,
    y2: 0.976,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d9eef8"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_173",
    x: 226.612,
    y: 167.136,
    width: 54.616,
    height: 54.616,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#57b0b6",
    floodOpacity: 0.298
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rechteck_62-2",
    x: 101,
    y: 0,
    width: 106,
    height: 87,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#57b0b6",
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Maske-2",
    "data-name": "Maske",
    d: "M2,0H74a2,2,0,0,1,2,2V57a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z",
    transform: "translate(-0.386 0.098)",
    fill: "#fff",
    stroke: "#ebeeeb",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_95",
    x: 126.878,
    y: 16.2,
    width: 54.616,
    height: 54.616,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#57b0b6",
    floodOpacity: 0.298
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rechteck_62-3",
    x: 0,
    y: 0,
    width: 106,
    height: 87,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#57b0b6",
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Maske-3",
    "data-name": "Maske",
    d: "M2,0H74a2,2,0,0,1,2,2V57a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z",
    transform: "translate(0 0.098)",
    fill: "#fff",
    stroke: "#ebeeeb",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_166",
    x: 24.57,
    y: 17.068,
    width: 54.616,
    height: 54.616,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#57b0b6",
    floodOpacity: 0.298
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rechteck_62-4",
    x: 101,
    y: 153,
    width: 105,
    height: 87,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#57b0b6",
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Maske-4",
    "data-name": "Maske",
    d: "M2,0H73a2,2,0,0,1,2,2V57a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z",
    transform: "translate(0.227 0.061)",
    fill: "#fff",
    stroke: "#ebeeeb",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_123",
    x: 125.61,
    y: 169.432,
    width: 54.616,
    height: 54.616,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#57b0b6",
    floodOpacity: 0.298
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rechteck_62-5",
    x: 0,
    y: 153,
    width: 106,
    height: 87,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#57b0b6",
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Maske-5",
    "data-name": "Maske",
    d: "M2,0H74a2,2,0,0,1,2,2V57a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z",
    transform: "translate(0 0.061)",
    fill: "#fff",
    stroke: "#ebeeeb",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_83",
    x: 25.503,
    y: 169.237,
    width: 54.616,
    height: 54.616,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#57b0b6",
    floodOpacity: 0.298
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rechteck_62-6",
    x: 253,
    y: 73,
    width: 105,
    height: 87,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-11"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#57b0b6",
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Maske-6",
    "data-name": "Maske",
    d: "M2,0H73a2,2,0,0,1,2,2V57a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z",
    transform: "translate(0.227 0.098)",
    fill: "#fff",
    stroke: "#ebeeeb",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_123-2",
    x: 277.61,
    y: 89.396,
    width: 54.616,
    height: 54.616,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-12"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#57b0b6",
    floodOpacity: 0.298
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rechteck_62-7",
    x: 153,
    y: 73,
    width: 106,
    height: 87,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-13"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#57b0b6",
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Maske-7",
    "data-name": "Maske",
    d: "M2,0H74a2,2,0,0,1,2,2V57a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z",
    transform: "translate(-0.16 0.061)",
    fill: "#fff",
    stroke: "#ebeeeb",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_161",
    x: 178.651,
    y: 89.237,
    width: 54.616,
    height: 54.616,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-14"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#57b0b6",
    floodOpacity: 0.298
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-14"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rechteck_62-8",
    x: 52,
    y: 73,
    width: 106,
    height: 87,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-15"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#57b0b6",
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-15"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Maske-8",
    "data-name": "Maske",
    d: "M2,0H74a2,2,0,0,1,2,2V57a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z",
    transform: "translate(-0.386 0.061)",
    fill: "#fff",
    stroke: "#ebeeeb",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_95-2",
    x: 77.878,
    y: 89.237,
    width: 54.616,
    height: 54.616,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-16"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#57b0b6",
    floodOpacity: 0.298
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-16"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "step-1-grafik",
    transform: "translate(-214 -3991.465)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Step-Point",
    transform: "translate(-226.525 90.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Differenzmenge_2",
    "data-name": "Differenzmenge 2",
    d: "M55.81,0a55.84,55.84,0,0,0-50.2,80.221L50.179,50.157,81.076,6.03A55.8,55.8,0,0,0,55.81,0Zm49.9,30.791h0L60.87,61.039,29.906,105.26a55.836,55.836,0,0,0,75.809-74.468Z",
    transform: "translate(566.147 4247.638) rotate(180)",
    fill: "#dbf1f7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 39.594,
    cy: 39.594,
    r: 39.594,
    transform: "translate(470.782 4152.208)",
    fill: "#73c9e2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_257",
    "data-name": "Pfad 257",
    d: "M4.469,0H-.812V-14.458l.051-2.375.085-2.6Q-1.991-18.115-2.5-17.705L-5.375-15.4l-2.546-3.179L.128-24.985H4.469Z",
    transform: "translate(284 4295)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "grafik-1",
    transform: "translate(101 -119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "konfi-produkte",
    transform: "translate(4 -197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Beitrag",
    transform: "translate(325.16 4472.367)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -216.16, -164.9)",
    filter: "url(#Rechteck_62)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_62-9",
    "data-name": "Rechteck 62",
    width: 76,
    height: 57,
    rx: 2,
    transform: "translate(216 165)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "verlauf-muster-schwung-kombi",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mustervorlage",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Verlauf",
    d: "M2,0H74a2,2,0,0,1,2,2V57a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z",
    transform: "translate(-0.16 0.098)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6",
    "data-name": "Gruppe 6",
    transform: "translate(0 0.089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6-2",
    "data-name": "Gruppe 6",
    transform: "translate(0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_52",
    "data-name": "Pfad 52",
    d: "M0,.009,78.462,0l.081,60.268L.081,60.277Z",
    transform: "translate(-1.054 -2.393)",
    fill: "url(#linear-gradient-2)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_11",
    "data-name": "Gruppe 11",
    transform: "translate(19.231 8.235)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -235.39, -173.14)",
    filter: "url(#Pfad_173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_173-2",
    "data-name": "Pfad 173",
    d: "M122.616,40.308a18.308,18.308,0,1,0-18.308,18.308,18.308,18.308,0,0,0,18.308-18.308",
    transform: "translate(149.61 151.14)",
    fill: "#dbf1f7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_174",
    "data-name": "Pfad 174",
    d: "M40.971,98.24a6.452,6.452,0,0,1-1.359-1.587A12.9,12.9,0,0,1,38.6,94.67a10.176,10.176,0,0,1-.6-3.492,5.282,5.282,0,0,1,.6-2.4,5.606,5.606,0,0,1,1.282-1.941,10.9,10.9,0,0,1,1.222-1.09c2.168-1.881,4.852-3.258,5.882-4.151.9-.779,4-3.594,6.589-3.594s5.69,2.815,6.589,3.594c1.03.893,3.714,2.27,5.882,4.151A12.377,12.377,0,0,1,67.3,86.919a6.3,6.3,0,0,1,1.246,1.857,5.282,5.282,0,0,1,.6,2.4,10.176,10.176,0,0,1-.6,3.492,11.516,11.516,0,0,1-1,1.971,6.19,6.19,0,0,1-1.372,1.6c-2.324,2.168-6.247,3.72-12.6,3.72s-10.285-1.551-12.6-3.72m16.2-4.666a3.594,3.594,0,1,0-3.594,3.594,3.6,3.6,0,0,0,3.594-3.594",
    transform: "translate(-35.155 -70.133)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_175",
    "data-name": "Pfad 175",
    d: "M201.594,238A3.594,3.594,0,1,1,198,241.594,3.6,3.6,0,0,1,201.594,238",
    transform: "translate(-183.175 -218.154)",
    fill: "#73c9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_176",
    "data-name": "Pfad 176",
    d: "M440.448,222.714a.45.45,0,0,1-.422-.6,9.68,9.68,0,0,0,.572-3.338,4.8,4.8,0,0,0-.551-2.2.449.449,0,1,1,.8-.4,5.758,5.758,0,0,1,.647,2.6,10.573,10.573,0,0,1-.626,3.647.45.45,0,0,1-.422.295",
    transform: "translate(-407.054 -197.728)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_177",
    "data-name": "Pfad 177",
    d: "M84.732,346.939c-5.842,0-10.185-1.292-12.91-3.841a.449.449,0,0,1,.614-.656c2.553,2.388,6.69,3.6,12.3,3.6s9.737-1.211,12.3-3.6a.449.449,0,1,1,.613.657c-2.731,2.548-7.075,3.84-12.909,3.84",
    transform: "translate(-66.313 -314.663)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_178",
    "data-name": "Pfad 178",
    d: "M33.048,222.714a.449.449,0,0,1-.422-.295A10.574,10.574,0,0,1,32,218.772a5.758,5.758,0,0,1,.647-2.6.449.449,0,0,1,.8.4,4.8,4.8,0,0,0-.551,2.2,9.678,9.678,0,0,0,.572,3.338.45.45,0,0,1-.422.6",
    transform: "translate(-29.604 -197.728)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_179",
    "data-name": "Pfad 179",
    d: "M98.829,80.643a.447.447,0,0,1-.294-.11,33.4,33.4,0,0,0-3.893-2.777,19.389,19.389,0,0,1-1.989-1.373l-.144-.125c-.952-.831-3.849-3.359-6.151-3.359s-5.2,2.528-6.151,3.359l-.144.125a19.39,19.39,0,0,1-1.989,1.373,33.4,33.4,0,0,0-3.893,2.777.449.449,0,0,1-.589-.679,34.13,34.13,0,0,1,4-2.855,19.069,19.069,0,0,0,1.885-1.3l.141-.123C80.738,74.6,83.718,72,86.358,72s5.62,2.6,6.742,3.581l.141.123A19.067,19.067,0,0,0,95.126,77a34.124,34.124,0,0,1,4,2.855.449.449,0,0,1-.295.789",
    transform: "translate(-67.939 -64.583)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_180",
    "data-name": "Pfad 180",
    d: "M172.428,108.493a.452.452,0,0,1-.134-.021,7.987,7.987,0,0,1-2.592-1.251l-.042-.045c-1.742-1.882-2.714-2.277-3.221-2.277s-1.479.4-3.221,2.277l-.044.047a7.991,7.991,0,0,1-2.591,1.249.449.449,0,0,1-.269-.857,7.543,7.543,0,0,0,2.2-1l.044-.047c.587-.635,2.375-2.566,3.881-2.566s3.293,1.931,3.881,2.566l.043.046a7.535,7.535,0,0,0,2.2,1,.449.449,0,0,1-.134.878",
    transform: "translate(-148.019 -94.187)",
    fill: "#979faf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_181",
    "data-name": "Pfad 181",
    d: "M196.043,240.086a4.043,4.043,0,1,1,4.043-4.043,4.048,4.048,0,0,1-4.043,4.043m0-7.188a3.145,3.145,0,1,0,3.145,3.145,3.148,3.148,0,0,0-3.145-3.145",
    transform: "translate(-177.624 -212.603)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_182",
    "data-name": "Pfad 182",
    d: "M31,17.071a.45.45,0,0,1-.429-.582,5.4,5.4,0,0,1,1.247-2.032c.341-.378.711-.732,1.1-1.108,1.486-1.426,3.022-2.9,3.022-5.712C35.939,5.285,33.214.9,28,.9a13.715,13.715,0,0,0-4.89,1.075,17.561,17.561,0,0,1-6.491,1.321,46.211,46.211,0,0,1-5.592-.32A38.313,38.313,0,0,0,6.439,2.7,5.385,5.385,0,0,0,.9,8.236c0,2.3,1.357,3.526,2.794,4.82a18.5,18.5,0,0,1,1.367,1.318A5.428,5.428,0,0,1,6.307,16.5a.449.449,0,0,1-.862.253,4.567,4.567,0,0,0-1.054-1.773,17.575,17.575,0,0,0-1.3-1.251C1.642,12.419,0,10.94,0,8.236A6.087,6.087,0,0,1,2.252,3.262,6.916,6.916,0,0,1,6.439,1.8a39.069,39.069,0,0,1,4.686.284,45.446,45.446,0,0,0,5.5.315A16.808,16.808,0,0,0,22.81,1.127,14.434,14.434,0,0,1,28,0a9.037,9.037,0,0,1,6.536,2.719,7.569,7.569,0,0,1,2.3,4.918c0,3.194-1.752,4.876-3.3,6.361-.38.364-.738.709-1.058,1.063a4.485,4.485,0,0,0-1.054,1.694.449.449,0,0,1-.429.317",
    transform: "translate(0 2.027)",
    fill: "#979faf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_183",
    "data-name": "Pfad 183",
    d: "M22.612,324.278a20.691,20.691,0,0,1-6.955-1.085,11.886,11.886,0,0,0-3.827-.712c-4.418,0-11.83-.6-11.83-4.642,0-2.362,2.958-4.35,4.23-5.1a9.158,9.158,0,0,1,1.466-.721.449.449,0,1,1,.29.85,8.31,8.31,0,0,0-1.3.646C2.854,314.591.9,316.288.9,317.839c0,1.359,1.272,2.374,3.781,3.018a30.8,30.8,0,0,0,7.151.726,12.778,12.778,0,0,1,4.092.751,19.912,19.912,0,0,0,6.69,1.046,11.36,11.36,0,0,0,6.466-2.055,8.373,8.373,0,0,1,1.789-.92,12.18,12.18,0,0,1,1.606-.324c2.094-.332,3.467-.667,3.467-2.241,0-1.968-2.357-3.555-3.762-4.326a13,13,0,0,0-1.343-.646.449.449,0,0,1,.327-.837,13.659,13.659,0,0,1,1.448.7c1.929,1.059,4.228,2.805,4.228,5.114,0,2.46-2.442,2.846-4.225,3.129a11.622,11.622,0,0,0-1.483.3,7.849,7.849,0,0,0-1.583.828,12.293,12.293,0,0,1-6.934,2.187",
    transform: "translate(0 -286.611)",
    fill: "#979faf"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Beitrag-2",
    "data-name": "Beitrag",
    transform: "translate(225.387 4319.367)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -116.39, -11.9)",
    filter: "url(#Rechteck_62-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_62-10",
    "data-name": "Rechteck 62",
    width: 76,
    height: 57,
    rx: 2,
    transform: "translate(116 12)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "verlauf-muster-schwung-kombi-2",
    "data-name": "verlauf-muster-schwung-kombi",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mustervorlage-2",
    "data-name": "Mustervorlage",
    transform: "translate(0)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Verlauf-2",
    "data-name": "Verlauf",
    d: "M2,0H74a2,2,0,0,1,2,2V57a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z",
    transform: "translate(-0.386 0.098)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6-3",
    "data-name": "Gruppe 6",
    transform: "translate(0 0.089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6-4",
    "data-name": "Gruppe 6",
    transform: "translate(0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_52-2",
    "data-name": "Pfad 52",
    d: "M0,.009,78.462,0l.081,60.268L.081,60.277Z",
    transform: "translate(-1.054 -2.393)",
    fill: "url(#linear-gradient-2)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "einmal-handschuhe",
    transform: "translate(19.492 10.298)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -135.88, -22.2)",
    filter: "url(#Pfad_95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_95-3",
    "data-name": "Pfad 95",
    d: "M106.6,18.308A18.308,18.308,0,1,0,88.3,36.616,18.308,18.308,0,0,0,106.6,18.308",
    transform: "translate(65.89 22.2)",
    fill: "#dbf1f7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_171",
    "data-name": "Pfad 171",
    d: "M28,1.654A2.174,2.174,0,0,0,25,1L12.546,9.12A16.5,16.5,0,0,0,12.5,4.8l-.184-1.281A4.086,4.086,0,0,0,8.342,0,1,1,0,0,0,7.32,1.011c0,.015,0,.03,0,.045l.432,3.786a5.555,5.555,0,0,1-.472,2.671L6.276,9.544A7.556,7.556,0,0,0,5.685,11.2c-.144.623-.294,1.553-.44,2.453-.106.656-.206,1.276-.3,1.73a3.748,3.748,0,0,1-1.5,2.329L.2,19.792a.434.434,0,0,0-.131.6l4.639,7.227a.433.433,0,0,0,.6.131l3.259-2.092a3.741,3.741,0,0,1,2.1-.6l2.046.035a7.206,7.206,0,0,0,4.03-1.144l3.968-2.462c.062-.032.122-.065.182-.1l3.192-2.049a2.134,2.134,0,0,0,.643-2.948l-.044-.069a2.124,2.124,0,0,0-1.213-.9,2.136,2.136,0,0,0,.069-2.408l-.044-.068a2.119,2.119,0,0,0-1.341-.932,2.163,2.163,0,0,0-.345-.046,2.164,2.164,0,0,0,.1-.333,2.12,2.12,0,0,0-.289-1.607l-.044-.069a2.117,2.117,0,0,0-1.04-.843l6.844-4.4A2.239,2.239,0,0,0,28,1.654",
    transform: "translate(1.848 8.876)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_97",
    "data-name": "Pfad 97",
    d: "M82.2,50s11.444-7.978,12.952-8.377c.9-.238,1.987.971,2.2,1.764s-3.141,2.976-6.669,5.181a74.016,74.016,0,0,1-6.614,4.244Z",
    transform: "translate(-67.477 -31.651)",
    fill: "#73c9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_172",
    "data-name": "Pfad 172",
    d: "M0,3.949a34.871,34.871,0,0,1,6.409-.88C8.135,2.661,11.869.231,12.654.023c.9-.238,1.008,1.438.527,3.345S10.3,6.182,6.4,7.692a11.041,11.041,0,0,1-2.5.6Z",
    transform: "matrix(0.438, -0.899, 0.899, 0.438, 4.138, 20.947)",
    fill: "#73c9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_170",
    "data-name": "Pfad 170",
    d: "M28,1.654A2.174,2.174,0,0,0,25,1L12.546,9.12A16.5,16.5,0,0,0,12.5,4.8l-.184-1.281A4.086,4.086,0,0,0,8.342,0,1,1,0,0,0,7.32,1.011c0,.015,0,.03,0,.045l.432,3.786a5.555,5.555,0,0,1-.472,2.671L6.276,9.544A7.556,7.556,0,0,0,5.685,11.2c-.144.623-.294,1.553-.44,2.453-.106.656-.206,1.276-.3,1.73a3.748,3.748,0,0,1-1.5,2.329L.2,19.792a.434.434,0,0,0,.469.73l3.255-2.089.017-.011A4.611,4.611,0,0,0,5.8,15.548c.093-.469.194-1.1.3-1.761.143-.886.291-1.8.428-2.4a6.687,6.687,0,0,1,.523-1.462L8.059,7.9a6.429,6.429,0,0,0,.562-3.088c0-.015,0-.03,0-.045L8.188.987A.133.133,0,0,1,8.227.905a.131.131,0,0,1,.1-.039,3.222,3.222,0,0,1,3.133,2.774l.184,1.281a15.632,15.632,0,0,1,0,4.411l-.452,3.188a.434.434,0,0,0,.1.341c.04.047,3.983,4.763,2.086,7.463a.434.434,0,1,0,.71.5c.961-1.368.882-3.292-.227-5.564a15.955,15.955,0,0,0-1.782-2.8l.315-2.225a.433.433,0,0,0,.122-.054l12.95-8.447a1.307,1.307,0,0,1,1.806.394,1.36,1.36,0,0,1-.357,1.863l-12.135,7.8h0l-.034.022a2.133,2.133,0,0,0-.643,2.948l.044.069a2.12,2.12,0,0,0,1.341.932,2.156,2.156,0,0,0,.346.047,2.132,2.132,0,0,0,.186,1.94l.044.068a2.131,2.131,0,0,0,1.629.973,2.157,2.157,0,0,0-.082.281,2.12,2.12,0,0,0,.289,1.607h0l.044.068a2.117,2.117,0,0,0,.994.825l-2.665,1.653a6.339,6.339,0,0,1-3.546,1.007l-2.046-.035a4.623,4.623,0,0,0-2.582.733L4.839,27.019a.434.434,0,1,0,.469.73l3.259-2.092a3.741,3.741,0,0,1,2.1-.6l2.046.035a7.206,7.206,0,0,0,4.03-1.144l3.968-2.462c.062-.032.122-.065.182-.1l3.192-2.049a2.134,2.134,0,0,0,.643-2.948l-.044-.069a2.124,2.124,0,0,0-1.213-.9,2.136,2.136,0,0,0,.069-2.408l-.044-.068a2.119,2.119,0,0,0-1.341-.932,2.163,2.163,0,0,0-.345-.046,2.164,2.164,0,0,0,.1-.333,2.12,2.12,0,0,0-.289-1.607l-.044-.069a2.117,2.117,0,0,0-1.04-.843l6.844-4.4A2.239,2.239,0,0,0,28,1.654M23.952,16.789l.044.069a1.266,1.266,0,0,1-.382,1.75l-3.162,2.03a.442.442,0,0,0-.078.04l-.088.054a1.264,1.264,0,0,1-1.614-.457l-.044-.068a1.266,1.266,0,0,1,.382-1.75L22.2,16.408a1.268,1.268,0,0,1,1.75.381M21.7,12.832a1.275,1.275,0,0,1,.272.029,1.258,1.258,0,0,1,.8.553l.044.068a1.266,1.266,0,0,1-.382,1.75l-.693.445h0l-3.192,2.049a1.268,1.268,0,0,1-1.75-.381l-.044-.068a1.268,1.268,0,0,1,.382-1.75l3.885-2.494a1.258,1.258,0,0,1,.682-.2m-.849-2.4.044.069a1.266,1.266,0,0,1-.382,1.75L16.624,14.74a1.266,1.266,0,0,1-1.75-.381l-.044-.068h0a1.266,1.266,0,0,1,.382-1.75l.034-.022h0l.012-.008L19.1,10.047a1.257,1.257,0,0,1,.682-.2,1.276,1.276,0,0,1,.272.03,1.258,1.258,0,0,1,.8.553",
    transform: "translate(1.848 8.876)",
    fill: "#474747"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Beitrag-3",
    "data-name": "Beitrag",
    transform: "translate(124 4319.367)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -11.9)",
    filter: "url(#Rechteck_62-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_62-11",
    "data-name": "Rechteck 62",
    width: 76,
    height: 57,
    rx: 2,
    transform: "translate(15 12)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "verlauf-muster-schwung-kombi-3",
    "data-name": "verlauf-muster-schwung-kombi",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mustervorlage-3",
    "data-name": "Mustervorlage",
    transform: "translate(0)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Verlauf-3",
    "data-name": "Verlauf",
    d: "M2,0H74a2,2,0,0,1,2,2V57a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z",
    transform: "translate(0 0.098)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6-5",
    "data-name": "Gruppe 6",
    transform: "translate(0 0.089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6-6",
    "data-name": "Gruppe 6",
    transform: "translate(0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_52-3",
    "data-name": "Pfad 52",
    d: "M0,.009,78.462,0l.081,60.268L.081,60.277Z",
    transform: "translate(-1.054 -2.393)",
    fill: "url(#linear-gradient-2)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_10",
    "data-name": "Gruppe 10",
    transform: "translate(18.57 8.877)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -33.57, -20.78)",
    filter: "url(#Pfad_166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_166-2",
    "data-name": "Pfad 166",
    d: "M66.616,72.308A18.308,18.308,0,1,0,48.308,90.616,18.308,18.308,0,0,0,66.616,72.308",
    transform: "translate(3.57 -30.93)",
    fill: "#dbf1f7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_167",
    "data-name": "Pfad 167",
    d: "M37.3,29.588V40.431H34.8V29.864a3.307,3.307,0,0,0-2.5-3.205v16.9H11.007v-16.9a3.308,3.308,0,0,0-2.5,3.205V40.431H6V29.588a6.265,6.265,0,0,1,4.645-6.047l.1-.024a6.264,6.264,0,0,0,4.645-6.047V12.26a6.26,6.26,0,0,1,12.52,0v5.209a6.264,6.264,0,0,0,4.645,6.047l.1.024A6.264,6.264,0,0,1,37.3,29.588M25.406,15.39V12.26a3.756,3.756,0,0,0-7.512,0v3.13Z",
    transform: "translate(-3.317 -5.53)",
    fill: "#73c9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_168",
    "data-name": "Pfad 168",
    d: "M26.762,38.5H5.478a.469.469,0,0,1-.47-.47V21.8a2.832,2.832,0,0,0-1.565,2.534V34.9a.469.469,0,0,1-.47.47H.47A.469.469,0,0,1,0,34.9V24.057a6.742,6.742,0,0,1,4.993-6.5l.01,0,.095-.023A5.8,5.8,0,0,0,9.39,11.938V6.73a6.73,6.73,0,0,1,13.459,0v5.209a5.8,5.8,0,0,0,4.292,5.593l.095.023.01,0a6.742,6.742,0,0,1,4.993,6.5V34.9a.47.47,0,0,1-.47.47h-2.5a.469.469,0,0,1-.47-.47V24.333A2.832,2.832,0,0,0,27.232,21.8V38.03a.47.47,0,0,1-.47.47M5.947,37.561H26.293V21.128a.469.469,0,0,1,.584-.455,3.771,3.771,0,0,1,2.859,3.661v10.1H31.3V24.057a5.8,5.8,0,0,0-4.292-5.593l-.095-.023-.01,0a6.742,6.742,0,0,1-4.993-6.5V6.73a5.791,5.791,0,0,0-11.581,0v5.209a6.742,6.742,0,0,1-4.993,6.5l-.01,0-.095.023A5.8,5.8,0,0,0,.939,24.057V34.431H2.5v-10.1a3.771,3.771,0,0,1,2.859-3.661.469.469,0,0,1,.584.455ZM5.215,17.986h0Z",
    transform: "translate(2.212 0)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_169",
    "data-name": "Pfad 169",
    d: "M159.982,39.825H152.47a.47.47,0,0,1-.47-.47v-3.13a4.226,4.226,0,0,1,8.451,0v3.13a.47.47,0,0,1-.47.47m-7.043-.939h6.573V36.226a3.287,3.287,0,1,0-6.573,0Z",
    transform: "translate(-137.893 -29.496)",
    fill: "#303e58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Beitrag-4",
    "data-name": "Beitrag",
    transform: "translate(224.773 4472.404)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -115.77, -164.94)",
    filter: "url(#Rechteck_62-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_62-12",
    "data-name": "Rechteck 62",
    width: 75,
    height: 57,
    rx: 2,
    transform: "translate(116 165)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "verlauf-muster-schwung-kombi-4",
    "data-name": "verlauf-muster-schwung-kombi",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mustervorlage-4",
    "data-name": "Mustervorlage",
    transform: "translate(0)",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Verlauf-4",
    "data-name": "Verlauf",
    d: "M2,0H73a2,2,0,0,1,2,2V57a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z",
    transform: "translate(0.227 0.061)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6-7",
    "data-name": "Gruppe 6",
    transform: "translate(0 0.089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6-8",
    "data-name": "Gruppe 6",
    transform: "translate(0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_52-4",
    "data-name": "Pfad 52",
    d: "M0,.009,78.462,0l.081,60.268L.081,60.277Z",
    transform: "translate(-1.054 -2.393)",
    fill: "url(#linear-gradient-2)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "handdes",
    transform: "translate(18.837 10.493)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -134.61, -175.43)",
    filter: "url(#Pfad_123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_123-3",
    "data-name": "Pfad 123",
    d: "M106.616,72.308A18.308,18.308,0,1,0,88.308,90.616a18.308,18.308,0,0,0,18.308-18.308",
    transform: "translate(64.61 121.43)",
    fill: "#dbf1f7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_124",
    "data-name": "Pfad 124",
    d: "M138.776,264.677h-2.248a.842.842,0,0,1-.843-.843,1.405,1.405,0,0,1,1.4-1.4h-2.248a.842.842,0,0,1-.843-.843,1.405,1.405,0,0,1,1.4-1.4h1.124a.842.842,0,0,1-.843-.843,1.405,1.405,0,0,1,1.4-1.4h8.642s-3.866-1.4-3.866-2.81c0-.7.421-1.124.877-1.124.354,0,2.529.967,3.619,1.124a15.666,15.666,0,0,1,7.271,2.422c.714.421,1.579,1.511,2.843,1.511h2.248v6.181H156.2a6.888,6.888,0,0,0-2.708.556l-1.337.573a6.888,6.888,0,0,1-2.708.556H138.214a.842.842,0,0,1-.843-.843,1.405,1.405,0,0,1,1.4-1.4",
    transform: "translate(-123.121 -236.135)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_125",
    "data-name": "Pfad 125",
    d: "M267.619,76.181c0,1.944-.938,2.81-2.81,2.81s-2.81-.865-2.81-2.81S264.81,70,264.81,70s2.81,4.237,2.81,6.181",
    transform: "translate(-242.13 -65.06)",
    fill: "#73c9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_126",
    "data-name": "Pfad 126",
    d: "M97.933,8.748c-.455.034-.843.061-1.124.061a7.015,7.015,0,0,1-1.124-.1A7.487,7.487,0,0,1,94,8.248V6.562a7.687,7.687,0,0,0,2.81.562c1.315,0,5.479-1.124,7.867-1.124a11.44,11.44,0,0,1,3.933,1.124L107.486,8.81a12.682,12.682,0,0,0-3.372-.562c-1.877,0-4.507.348-6.181.5",
    transform: "translate(-85.93 -5.555)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_127",
    "data-name": "Pfad 127",
    d: "M26.724,198.429H18.081a1.405,1.405,0,0,0-1.4,1.4.842.842,0,0,0,.843.843H16.4a1.405,1.405,0,0,0-1.4,1.4.842.842,0,0,0,.843.843h2.248a1.405,1.405,0,0,0-1.4,1.4.842.842,0,0,0,.843.843h2.248a1.405,1.405,0,0,0-1.4,1.4.842.842,0,0,0,.843.843h4.776v1.686a1.683,1.683,0,0,1-1.686,1.686H7.686A1.683,1.683,0,0,1,6,209.105V194.13a2.242,2.242,0,0,1,1.158-1.961l3.9-2.169h7.867l3.9,2.169a1.993,1.993,0,0,1,.416.3,2.937,2.937,0,0,1,.494,2.028c-.455,0-.877.421-.877,1.124,0,1.4,3.866,2.81,3.866,2.81",
    transform: "translate(-4.111 -176.631)",
    fill: "#73c9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_128",
    "data-name": "Pfad 128",
    d: "M85.867,126v4.5H78V126h7.867Z",
    transform: "translate(-71.054 -117.126)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_129",
    "data-name": "Pfad 129",
    d: "M106.5,86v2.81H102V86h4.5Z",
    transform: "translate(-93.368 -79.936)",
    fill: "#73c9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_130",
    "data-name": "Pfad 130",
    d: "M120.248,44.675v2.871H118V44.641a7.015,7.015,0,0,0,1.124.1c.281,0,.669-.028,1.124-.061",
    transform: "translate(-108.244 -41.482)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_131",
    "data-name": "Pfad 131",
    d: "M183.165,336.843h-6.743a.421.421,0,1,1,0-.843h6.743a.421.421,0,1,1,0,.843",
    transform: "translate(-162.17 -312.376)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_132",
    "data-name": "Pfad 132",
    d: "M153.264,307.091A1.266,1.266,0,0,1,152,305.826,1.828,1.828,0,0,1,153.826,304h9.834a.421.421,0,1,1,0,.843h-9.834a.984.984,0,0,0-.983.983.422.422,0,0,0,.421.421.421.421,0,1,1,0,.843",
    transform: "translate(-139.856 -282.624)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_133",
    "data-name": "Pfad 133",
    d: "M138.536,339.091h-9.272A1.266,1.266,0,0,1,128,337.826,1.828,1.828,0,0,1,129.826,336h1.967a.421.421,0,1,1,0,.843h-1.967a.984.984,0,0,0-.983.983.422.422,0,0,0,.421.421h9.272a.421.421,0,0,1,0,.843",
    transform: "translate(-117.542 -312.376)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_134",
    "data-name": "Pfad 134",
    d: "M160.85,371.091h-7.586A1.266,1.266,0,0,1,152,369.826,1.828,1.828,0,0,1,153.826,368a.421.421,0,1,1,0,.843.984.984,0,0,0-.983.983.422.422,0,0,0,.421.421h7.586a.421.421,0,1,1,0,.843",
    transform: "translate(-139.856 -342.128)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_135",
    "data-name": "Pfad 135",
    d: "M188.5,403.091H177.264A1.266,1.266,0,0,1,176,401.826,1.828,1.828,0,0,1,177.826,400a.421.421,0,0,1,0,.843.984.984,0,0,0-.983.983.422.422,0,0,0,.421.421H188.5a6.428,6.428,0,0,0,2.543-.522l1.337-.573a7.266,7.266,0,0,1,2.874-.591h2.523a.421.421,0,1,1,0,.843h-2.523a6.428,6.428,0,0,0-2.543.522l-1.337.573a7.266,7.266,0,0,1-2.874.591",
    transform: "translate(-162.17 -371.88)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_136",
    "data-name": "Pfad 136",
    d: "M257.279,253.9h-2.248a3.96,3.96,0,0,1-2.469-1.133,5.6,5.6,0,0,0-.589-.436,14.84,14.84,0,0,0-6.717-2.31l-.4-.058a15.184,15.184,0,0,1-2.5-.76,11.069,11.069,0,0,0-1.071-.359c-.218.007-.446.252-.446.7,0,.756,2.141,1.887,3.589,2.414a.421.421,0,0,1-.288.792,16.267,16.267,0,0,1-1.991-.9c-1.449-.79-2.153-1.542-2.153-2.3A1.4,1.4,0,0,1,241.3,248a5.354,5.354,0,0,1,1.351.41,14.808,14.808,0,0,0,2.328.718l.4.058A15.517,15.517,0,0,1,252.4,251.6a6.151,6.151,0,0,1,.689.506,3.255,3.255,0,0,0,1.941.947h2.248a.421.421,0,1,1,0,.843",
    transform: "translate(-221.675 -230.557)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_137",
    "data-name": "Pfad 137",
    d: "M80.288,125.338H72.421a.421.421,0,0,1,0-.843h7.445v-3.652H72.843v1.826a.421.421,0,1,1-.843,0v-2.248a.422.422,0,0,1,.421-.421h7.867a.422.422,0,0,1,.421.421v4.5a.422.422,0,0,1-.421.421",
    transform: "translate(-65.476 -111.548)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_138",
    "data-name": "Pfad 138",
    d: "M100.917,83.653a.422.422,0,0,1-.421-.421V80.843H96.843v.7a.421.421,0,0,1-.843,0V80.421A.422.422,0,0,1,96.421,80h4.5a.422.422,0,0,1,.421.421v2.81a.422.422,0,0,1-.421.421",
    transform: "translate(-87.79 -74.357)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_139",
    "data-name": "Pfad 139",
    d: "M144.421,42.534a.422.422,0,0,1-.421-.421V39.218a.421.421,0,1,1,.843,0v2.894a.422.422,0,0,1-.421.421",
    transform: "translate(-132.418 -36.048)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_140",
    "data-name": "Pfad 140",
    d: "M112.421,42.389a.422.422,0,0,1-.421-.421V39.062a.421.421,0,1,1,.843,0v2.905a.422.422,0,0,1-.421.421",
    transform: "translate(-102.666 -35.903)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_141",
    "data-name": "Pfad 141",
    d: "M101.908,3.653a.42.42,0,0,1-.13-.021,12.342,12.342,0,0,0-3.241-.541c-1.363,0-3.112.185-4.654.348-.538.057-1.047.111-1.489.151h-.007c-.438.032-.851.063-1.155.063a7.432,7.432,0,0,1-1.191-.1,7.877,7.877,0,0,1-1.79-.5A.422.422,0,0,1,88,2.669V.983A.422.422,0,0,1,88.593.6a7.333,7.333,0,0,0,2.638.526A21.53,21.53,0,0,0,94.026.693,31.11,31.11,0,0,1,99.1,0a11.708,11.708,0,0,1,4.119,1.167.421.421,0,0,1,.165.612l-1.124,1.686a.422.422,0,0,1-.351.188M88.843,2.381a7.6,7.6,0,0,0,1.331.339h0a6.593,6.593,0,0,0,1.056.09c.272,0,.669-.029,1.089-.06s.939-.093,1.473-.149c1.564-.165,3.336-.353,4.743-.353a12.639,12.639,0,0,1,3.194.491l.676-1.014A9.77,9.77,0,0,0,99.1.843a30.63,30.63,0,0,0-4.915.679,20.991,20.991,0,0,1-2.952.445,8.112,8.112,0,0,1-2.388-.382Z",
    transform: "translate(-80.352 0.023)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_142",
    "data-name": "Pfad 142",
    d: "M16.717,205.633H2.107A2.11,2.11,0,0,1,0,203.525V188.55a2.662,2.662,0,0,1,1.375-2.33l3.9-2.168a.421.421,0,1,1,.41.737l-3.9,2.169a1.82,1.82,0,0,0-.941,1.593v14.975a1.266,1.266,0,0,0,1.264,1.264h14.61a1.266,1.266,0,0,0,1.264-1.264.421.421,0,1,1,.843,0,2.11,2.11,0,0,1-2.107,2.107",
    transform: "translate(1.467 -171.051)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_143",
    "data-name": "Pfad 143",
    d: "M188.32,187.01a.42.42,0,0,1-.2-.053l-3.9-2.169a.421.421,0,0,1,.41-.737l3.9,2.169a.422.422,0,0,1-.205.79",
    transform: "translate(-169.608 -171.051)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_144",
    "data-name": "Pfad 144",
    d: "M259.231,73.834c-2.144,0-3.231-1.087-3.231-3.231,0-2.048,2.762-6.237,2.88-6.414a.421.421,0,0,1,.7,0c.118.177,2.88,4.366,2.88,6.414,0,2.144-1.087,3.231-3.231,3.231m0-8.631c-.891,1.43-2.388,4.1-2.388,5.4,0,1.674.714,2.388,2.388,2.388s2.388-.714,2.388-2.388c0-1.3-1.5-3.97-2.388-5.4",
    transform: "translate(-236.551 -59.481)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_145",
    "data-name": "Pfad 145",
    d: "M280.455,154.972h-.019a1.606,1.606,0,0,1-.97-.388l-.009-.008a1.576,1.576,0,0,1-.49-.877.421.421,0,0,1,.829-.151.728.728,0,0,0,.224.4.759.759,0,0,0,.453.181.421.421,0,0,1-.018.842",
    transform: "translate(-257.898 -142.418)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Beitrag-5",
    "data-name": "Beitrag",
    transform: "translate(124 4472.404)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -164.94)",
    filter: "url(#Rechteck_62-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_62-13",
    "data-name": "Rechteck 62",
    width: 76,
    height: 57,
    rx: 2,
    transform: "translate(15 165)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "verlauf-muster-schwung-kombi-5",
    "data-name": "verlauf-muster-schwung-kombi",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mustervorlage-5",
    "data-name": "Mustervorlage",
    transform: "translate(0)",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Verlauf-5",
    "data-name": "Verlauf",
    d: "M2,0H74a2,2,0,0,1,2,2V57a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z",
    transform: "translate(0 0.061)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6-9",
    "data-name": "Gruppe 6",
    transform: "translate(0 0.089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6-10",
    "data-name": "Gruppe 6",
    transform: "translate(0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_52-5",
    "data-name": "Pfad 52",
    d: "M0,.009,78.462,0l.081,60.268L.081,60.277Z",
    transform: "translate(-1.054 -2.393)",
    fill: "url(#linear-gradient-2)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "mundschutz",
    transform: "translate(15.333 10.298)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -30.33, -175.24)",
    filter: "url(#Pfad_83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_83-2",
    "data-name": "Pfad 83",
    d: "M82.616,18.308A18.308,18.308,0,1,0,64.308,36.616,18.308,18.308,0,0,0,82.616,18.308",
    transform: "translate(-11.5 175.24)",
    fill: "#dbf1f7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vereinigungsmenge_6",
    "data-name": "Vereinigungsmenge 6",
    d: "M.044,15.955s.236-1.175.443-2.589a24.321,24.321,0,0,0,10.105,3.858A24.317,24.317,0,0,1,.487,13.365c.125-.876.243-1.841.28-2.668.008-.188.015-.37.015-.544C.782,9.66.737,9.007.671,8.3.582,7.273.443,6.135.317,5.164h.17c.125-.312,3.82-.414,3.82-.414a25.483,25.483,0,0,0,3.112-.4C9.062,3.945,10.8,2.915,13.251,2.9c2.456.014,4.2,1.044,5.84,1.45,1.711.421,5.457.377,7.05,1.211-.111.878-.229,1.85-.31,2.734-.059.711-.1,1.364-.1,1.857,0,.174.007.356.015.544.037.827.155,1.792.28,2.668a24.314,24.314,0,0,1-10.109,3.858,24.318,24.318,0,0,0,10.109-3.858c.207,1.414.443,2.589.443,2.589a23.778,23.778,0,0,1-13.214,4.351A23.77,23.77,0,0,1,.044,15.955Zm19.047-11.6c-1.644-.407-3.385-1.436-5.84-1.45-2.456.014-4.188,1.044-5.833,1.45a25.483,25.483,0,0,1-3.112.4s-3.695.1-3.82.414H.317C.148,3.88,0,2.9,0,2.9c1.29-1.088,5.56-.994,7.418-1.45C9.062,1.044,10.8.014,13.251,0c2.456.014,4.2,1.044,5.84,1.45,1.858.457,6.128.363,7.418,1.45,0,0-.177,1.19-.369,2.661C24.548,4.728,20.8,4.772,19.091,4.351Z",
    transform: "translate(9.326 9.638)",
    fill: "#73c9e2",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_87",
    "data-name": "Pfad 87",
    d: "M116.569,251.547a24.3,24.3,0,0,1-13.019-4.118.431.431,0,0,1-.11-.606.447.447,0,0,1,.616-.108,21.751,21.751,0,0,0,25.031,0,.447.447,0,0,1,.616.108.431.431,0,0,1-.11.606,24.308,24.308,0,0,1-13.024,4.118",
    transform: "translate(-93.99 -224.025)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_88",
    "data-name": "Pfad 88",
    d: "M166.71,134.732a.433.433,0,0,1-.2-.051,13.919,13.919,0,0,0-4.221-.811,20.607,20.607,0,0,1-2.613-.362,16.451,16.451,0,0,1-1.625-.534,9.351,9.351,0,0,0-8.017,0,16.35,16.35,0,0,1-1.626.535,20.686,20.686,0,0,1-2.721.371l-.4.039a.435.435,0,0,1-.085-.866l.4-.039a20.293,20.293,0,0,0,2.592-.348,15.752,15.752,0,0,0,1.538-.508,10.186,10.186,0,0,1,8.617,0,15.793,15.793,0,0,0,1.538.507,20.194,20.194,0,0,0,2.488.34,14.008,14.008,0,0,1,4.544.909.435.435,0,0,1-.2.819",
    transform: "translate(-131.417 -119.177)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_89",
    "data-name": "Pfad 89",
    d: "M317.283,177.037a.433.433,0,0,1-.174-.037,17.028,17.028,0,0,0-5.976-1.414.435.435,0,0,1,.045-.869,17.9,17.9,0,0,1,6.28,1.486.435.435,0,0,1-.175.834",
    transform: "translate(-282.225 -158.712)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_90",
    "data-name": "Pfad 90",
    d: "M105.795,177.036a.435.435,0,0,1-.174-.834,17.974,17.974,0,0,1,6.287-1.486.435.435,0,1,1,.045.869A17.108,17.108,0,0,0,105.969,177a.433.433,0,0,1-.174.036",
    transform: "translate(-95.697 -158.711)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_91",
    "data-name": "Pfad 91",
    d: "M316.116,219.977a.435.435,0,0,1-.022-.87,10.285,10.285,0,0,0,5.365-1.83.435.435,0,1,1,.5.714,11.156,11.156,0,0,1-5.818,1.985h-.022",
    transform: "translate(-286.736 -197.301)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_92",
    "data-name": "Pfad 92",
    d: "M112.426,219.976H112.4a11.156,11.156,0,0,1-5.818-1.985.435.435,0,0,1,.5-.714,10.286,10.286,0,0,0,5.365,1.83.435.435,0,0,1-.022.87",
    transform: "translate(-96.643 -197.3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_93",
    "data-name": "Pfad 93",
    d: "M40.827,99.45a7.633,7.633,0,0,0-2.66.741,8.851,8.851,0,0,1-2.252.7c-1.032-.7-3-.9-4.91-1.087a20.46,20.46,0,0,1-2.494-.336,16.032,16.032,0,0,1-1.542-.5,12.5,12.5,0,0,0-4.4-.963,12.447,12.447,0,0,0-4.381.962,15.924,15.924,0,0,1-1.541.5,20.454,20.454,0,0,1-2.494.336c-1.915.189-3.891.385-4.921,1.095a8.089,8.089,0,0,1-2.368-.707,7.614,7.614,0,0,0-2.657-.741c-2.558,0-4.211,1.921-4.211,4.9,0,3.459,1.88,4.8,4.26,6.488a24.642,24.642,0,0,1,4.662,4.02.548.548,0,0,0,.349.184,23.915,23.915,0,0,0,13.308,4.356,23.847,23.847,0,0,0,13.461-4.467l.01-.009c.013-.011.025-.022.038-.034l.017-.018.012-.012a24.645,24.645,0,0,1,4.662-4.02c2.38-1.693,4.26-3.03,4.26-6.488,0-2.974-1.653-4.9-4.211-4.9M4.9,109.95c-2.29-1.628-3.8-2.7-3.8-5.6,0-.893.224-3.807,3.112-3.807a7.1,7.1,0,0,1,2.242.66,9.94,9.94,0,0,0,2.485.766c.058.406.15,1.058.249,1.811.116.9.26,2.073.349,3.114.071.771.107,1.379.107,1.807,0,.165-.007.347-.014.52-.03.674-.119,1.53-.273,2.615-.087.6-.179,1.157-.257,1.6a27.346,27.346,0,0,0-4.2-3.48m17.678,8.355a23.189,23.189,0,0,1-12.513-4.043c.085-.455.24-1.315.379-2.278.159-1.122.252-2.011.283-2.723.007-.186.015-.379.015-.565,0-.468-.037-1.092-.112-1.9-.091-1.057-.237-2.241-.354-3.156-.109-.833-.21-1.543-.267-1.939a13.978,13.978,0,0,1,4.257-.813,20.97,20.97,0,0,0,2.652-.364,16.714,16.714,0,0,0,1.653-.538,11.371,11.371,0,0,1,4-.9,11.42,11.42,0,0,1,4.017.9,16.819,16.819,0,0,0,1.653.538,20.975,20.975,0,0,0,2.651.363,13.975,13.975,0,0,1,4.257.814c-.066.457-.19,1.337-.319,2.34-.107.856-.228,1.852-.31,2.756-.049.59-.1,1.339-.1,1.9,0,.187.008.379.015.568.031.709.124,1.6.283,2.722.14.962.294,1.822.379,2.276a23.141,23.141,0,0,1-12.518,4.043m17.558-8.355a27.734,27.734,0,0,0-4.094,3.371c-.073-.423-.158-.938-.238-1.488-.154-1.087-.244-1.943-.273-2.614-.007-.175-.014-.357-.014-.522,0-.523.054-1.244.1-1.808.08-.884.2-1.869.305-2.713.12-.93.236-1.753.3-2.227a10.661,10.661,0,0,0,2.355-.749,7.124,7.124,0,0,1,2.245-.661c2.888,0,3.112,2.914,3.112,3.807,0,2.9-1.513,3.976-3.8,5.6",
    transform: "translate(0 -88.903)",
    fill: "#3f3f3f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Beitrag-6",
    "data-name": "Beitrag",
    transform: "translate(376.773 4392.367)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -267.77, -84.9)",
    filter: "url(#Rechteck_62-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_62-14",
    "data-name": "Rechteck 62",
    width: 75,
    height: 57,
    rx: 2,
    transform: "translate(268 85)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "verlauf-muster-schwung-kombi-6",
    "data-name": "verlauf-muster-schwung-kombi",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mustervorlage-6",
    "data-name": "Mustervorlage",
    transform: "translate(0)",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Verlauf-6",
    "data-name": "Verlauf",
    d: "M2,0H73a2,2,0,0,1,2,2V57a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z",
    transform: "translate(0.227 0.098)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6-11",
    "data-name": "Gruppe 6",
    transform: "translate(0 0.089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6-12",
    "data-name": "Gruppe 6",
    transform: "translate(0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_52-6",
    "data-name": "Pfad 52",
    d: "M0,.009,78.462,0l.081,60.268L.081,60.277Z",
    transform: "translate(-1.054 -2.393)",
    fill: "url(#linear-gradient-2)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "handdes-2",
    "data-name": "handdes",
    transform: "translate(17.849 9.382)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -285.62, -94.28)",
    filter: "url(#Pfad_123-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_123-4",
    "data-name": "Pfad 123",
    d: "M106.616,72.308A18.308,18.308,0,1,0,88.308,90.616a18.308,18.308,0,0,0,18.308-18.308",
    transform: "translate(216.61 41.4)",
    fill: "#dbf1f7"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_69",
    "data-name": "Rechteck 69",
    width: 18,
    height: 3,
    transform: "translate(12.378 34.716)",
    fill: "#ebedf0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_70",
    "data-name": "Rechteck 70",
    width: 4,
    height: 3,
    transform: "translate(34.378 34.716)",
    fill: "#ebedf0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_71",
    "data-name": "Rechteck 71",
    width: 4,
    height: 18,
    transform: "translate(34.378 12.716)",
    fill: "#ebedf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_184",
    "data-name": "Pfad 184",
    d: "M14.791,289.768H6V286H17.93v3.767Z",
    transform: "translate(-5.529 -263.553)",
    fill: "#ebedf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_185",
    "data-name": "Pfad 185",
    d: "M289.767,14.791v3.14H286V6h3.767Z",
    transform: "translate(-263.552 -5.529)",
    fill: "#ebedf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_186",
    "data-name": "Pfad 186",
    d: "M6,238H17.93v3.767H6Z",
    transform: "translate(-5.529 -219.32)",
    fill: "#73c9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_187",
    "data-name": "Pfad 187",
    d: "M241.767,14.791v3.14H238V6h3.767Z",
    transform: "translate(-219.32 -5.529)",
    fill: "#73c9e2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_72",
    "data-name": "Rechteck 72",
    width: 4,
    height: 4,
    transform: "translate(34.378 30.716)",
    fill: "#73c9e2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_73",
    "data-name": "Rechteck 73",
    width: 18,
    height: 4,
    transform: "translate(12.378 30.716)",
    fill: "#73c9e2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_74",
    "data-name": "Rechteck 74",
    width: 4,
    height: 3,
    transform: "translate(30.378 34.716)",
    fill: "#73c9e2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_75",
    "data-name": "Rechteck 75",
    width: 4,
    height: 18,
    transform: "translate(30.378 12.716)",
    fill: "#73c9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_188",
    "data-name": "Pfad 188",
    d: "M176.209,158v18.209H158v-15.7A2.511,2.511,0,0,1,160.512,158h15.7Z",
    transform: "translate(-145.599 -145.599)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_189",
    "data-name": "Pfad 189",
    d: "M6,8.512A2.511,2.511,0,0,1,8.512,6h15.7V17.93H20.442a2.511,2.511,0,0,0-2.512,2.512v3.767H6V8.512Z",
    transform: "translate(-5.529 -5.529)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_190",
    "data-name": "Pfad 190",
    d: "M178.215,152H154.983A2.986,2.986,0,0,0,152,154.983v23.232a.471.471,0,0,0,.471.471h25.744a.471.471,0,0,0,.471-.471V152.471a.471.471,0,0,0-.471-.471m-7.064,19.151h2.826v2.826h-2.826Zm2.826,6.593h-2.826v-2.826h2.826Zm-21.035-6.593h17.267v2.826H152.942Zm18.209-18.209h2.826v17.267h-2.826Zm3.767,18.209h2.826v2.826h-2.826Zm2.826-.942h-2.826V152.942h2.826Zm-22.761-17.267h15.227v17.267H152.942V154.983a2.043,2.043,0,0,1,2.041-2.041m-2.041,21.977h17.267v2.826H152.942Zm21.977,0h2.826v2.826h-2.826Z",
    transform: "translate(-140.07 -140.07)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_191",
    "data-name": "Pfad 191",
    d: "M9.262,19.151a.471.471,0,0,0,0-.942H.942V2.983A2.043,2.043,0,0,1,2.983.942H18.209v8.32a.471.471,0,1,0,.942,0V.942h2.826v8.32a.471.471,0,1,0,.942,0V.942h2.826v8.32a.471.471,0,1,0,.942,0V.471A.471.471,0,0,0,26.215,0H2.983A2.986,2.986,0,0,0,0,2.983V26.215a.471.471,0,0,0,.471.471H9.262a.471.471,0,0,0,0-.942H.942V22.918h8.32a.471.471,0,1,0,0-.942H.942V19.151Z",
    transform: "translate(0 0)",
    fill: "#303e58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Beitrag-7",
    "data-name": "Beitrag",
    transform: "translate(277.16 4392.404)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -168.16, -84.94)",
    filter: "url(#Rechteck_62-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_62-15",
    "data-name": "Rechteck 62",
    width: 76,
    height: 57,
    rx: 2,
    transform: "translate(168 85)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "verlauf-muster-schwung-kombi-7",
    "data-name": "verlauf-muster-schwung-kombi",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mustervorlage-7",
    "data-name": "Mustervorlage",
    transform: "translate(0)",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Verlauf-7",
    "data-name": "Verlauf",
    d: "M2,0H74a2,2,0,0,1,2,2V57a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z",
    transform: "translate(-0.16 0.061)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6-13",
    "data-name": "Gruppe 6",
    transform: "translate(0 0.089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6-14",
    "data-name": "Gruppe 6",
    transform: "translate(0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_52-7",
    "data-name": "Pfad 52",
    d: "M0,.009,78.462,0l.081,60.268L.081,60.277Z",
    transform: "translate(-1.054 -2.393)",
    fill: "url(#linear-gradient-2)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_9",
    "data-name": "Gruppe 9",
    transform: "translate(19.492 10.134)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -187.65, -95.07)",
    filter: "url(#Pfad_161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_161-2",
    "data-name": "Pfad 161",
    d: "M106.6,18.308A18.308,18.308,0,1,0,88.3,36.616,18.308,18.308,0,0,0,106.6,18.308",
    transform: "translate(117.66 95.24)",
    fill: "#dbf1f7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_146",
    "data-name": "Pfad 146",
    d: "M147.172,31.612a.525.525,0,1,1,0-1.049.525.525,0,1,1,0,1.049",
    transform: "translate(-120.216 -27.658)",
    fill: "#979faf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_147",
    "data-name": "Pfad 147",
    d: "M145.359,51.963a.528.528,0,0,1,.532-.525.525.525,0,1,1,0,1.05.528.528,0,0,1-.532-.525",
    transform: "translate(-119.056 -46.549)",
    fill: "#979faf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_148",
    "data-name": "Pfad 148",
    d: "M125.678,19.039a.62.62,0,1,1,0,1.239.62.62,0,1,1,0-1.239",
    transform: "translate(-100.668 -17.229)",
    fill: "#979faf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_149",
    "data-name": "Pfad 149",
    d: "M17.406,276v2.281a1.525,1.525,0,0,1-1.521,1.521H7.521A1.525,1.525,0,0,1,6,278.281V276H17.406Z",
    transform: "translate(7.057 -249.767)",
    fill: "#73c9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_150",
    "data-name": "Pfad 150",
    d: "M165.675,32.027a.433.433,0,0,1-.441.426.426.426,0,1,1,0-.852.433.433,0,0,1,.441.426",
    transform: "translate(-136.65 -28.597)",
    fill: "#979faf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_151",
    "data-name": "Pfad 151",
    d: "M17.406,172v9.885H6V172H17.406Z",
    transform: "translate(7.057 -155.652)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_152",
    "data-name": "Pfad 152",
    d: "M163.64,62.961a.43.43,0,1,1-.441.433.435.435,0,0,1,.441-.433",
    transform: "translate(-135.201 -56.977)",
    fill: "#979faf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_153",
    "data-name": "Pfad 153",
    d: "M17.406,118.912v2.41H6v-2.41a1.525,1.525,0,0,1,.449-1.08L8.281,116h6.843l1.833,1.833a1.525,1.525,0,0,1,.449,1.08",
    transform: "translate(7.057 -104.974)",
    fill: "#73c9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_154",
    "data-name": "Pfad 154",
    d: "M126.309,40.547a.626.626,0,0,1-.631.616.62.62,0,1,1,.631-.616",
    transform: "translate(-100.668 -36.128)",
    fill: "#979faf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_155",
    "data-name": "Pfad 155",
    d: "M146.432,10.041a.534.534,0,0,1-.54.525.525.525,0,1,1,0-1.05.534.534,0,0,1,.54.525",
    transform: "translate(-119.057 -8.612)",
    fill: "#979faf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_156",
    "data-name": "Pfad 156",
    d: "M163.64,0a.434.434,0,0,1,.441.426.441.441,0,0,1-.882,0A.434.434,0,0,1,163.64,0",
    transform: "translate(-135.201 0)",
    fill: "#979faf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_157",
    "data-name": "Pfad 157",
    d: "M102.73,28.563a.715.715,0,1,1-.73.714.722.722,0,0,1,.73-.714",
    transform: "translate(-79.819 -25.848)",
    fill: "#979faf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_158",
    "data-name": "Pfad 158",
    d: "M36.844,68v4.562H30V68h6.843Z",
    transform: "translate(-14.662 -61.537)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_159",
    "data-name": "Pfad 159",
    d: "M49.8,17.323H46V12h3.8v1.293a.913.913,0,0,0-.509-.152,1.149,1.149,0,0,0,0,2.281.976.976,0,0,0,.509-.152v2.053Z",
    transform: "translate(-29.141 -10.859)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_160",
    "data-name": "Pfad 160",
    d: "M11.931,17.885l-1.666-1.666V11.893a.57.57,0,0,0-.57-.57h-.95V6.57A.57.57,0,0,0,8.174,6h-3.8a.57.57,0,0,0-.57.57v4.752h-.95a.57.57,0,0,0-.57.57v4.326L.616,17.885A2.084,2.084,0,0,0,0,19.368V33.944a2.093,2.093,0,0,0,2.091,2.091h8.364a2.093,2.093,0,0,0,2.091-2.091V19.368a2.084,2.084,0,0,0-.616-1.483M4.942,7.141H7.6v.574a1.092,1.092,0,0,0-.95,1.137A1.1,1.1,0,0,0,7.6,9.988v1.334H4.942ZM3.422,12.463h5.7v3.422h-5.7Zm7.984,8.744H3.612a.57.57,0,0,0,0,1.141h7.794v8.744H3.612a.57.57,0,1,0,0,1.141h7.794v1.711a.952.952,0,0,1-.95.95H2.091a.952.952,0,0,1-.95-.95V19.368a.951.951,0,0,1,.281-.676l1.666-1.666H9.459l1.666,1.666a.951.951,0,0,1,.281.676Z",
    transform: "translate(12.487 -5.43)",
    fill: "#303e58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Beitrag-8",
    "data-name": "Beitrag",
    transform: "translate(176.387 4392.404)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -67.39, -84.94)",
    filter: "url(#Rechteck_62-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_62-16",
    "data-name": "Rechteck 62",
    width: 76,
    height: 57,
    rx: 2,
    transform: "translate(67 85)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "verlauf-muster-schwung-kombi-8",
    "data-name": "verlauf-muster-schwung-kombi",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mustervorlage-8",
    "data-name": "Mustervorlage",
    transform: "translate(0)",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Verlauf-8",
    "data-name": "Verlauf",
    d: "M2,0H74a2,2,0,0,1,2,2V57a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z",
    transform: "translate(-0.386 0.061)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6-15",
    "data-name": "Gruppe 6",
    transform: "translate(0 0.089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6-16",
    "data-name": "Gruppe 6",
    transform: "translate(0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_52-8",
    "data-name": "Pfad 52",
    d: "M0,.009,78.462,0l.081,60.268L.081,60.277Z",
    transform: "translate(-1.054 -2.393)",
    fill: "url(#linear-gradient-2)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "einmal-handschuhe-2",
    "data-name": "einmal-handschuhe",
    transform: "translate(16.25 10.298)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -83.64, -95.24)",
    filter: "url(#Pfad_95-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_95-4",
    "data-name": "Pfad 95",
    d: "M106.6,18.308A18.308,18.308,0,1,0,88.3,36.616,18.308,18.308,0,0,0,106.6,18.308",
    transform: "translate(16.89 95.24)",
    fill: "#dbf1f7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_96",
    "data-name": "Pfad 96",
    d: "M285.853,16.129a1.555,1.555,0,0,1,1.907-1.087,1.533,1.533,0,0,1,1.1,1.886l-2.874,10.635a7.4,7.4,0,0,1-1.388,2.713,12.8,12.8,0,0,0-2.307,3.772,44.989,44.989,0,0,0-.855,5.531,8.99,8.99,0,0,1-6.2.274,9.644,9.644,0,0,1-5.244-3.309s1.557-3.357,1.823-4.353c.435-1.606-.834-3.842-.947-4.851-.182-1.564.414-3.856.5-5.139.175-2.489-.806-4.48-.589-5.272a1.068,1.068,0,0,1,1.528-.876c1.508.4,2.517,3.841,2.489,5.139l2.986-11.035a1.511,1.511,0,0,1,.729-.939,1.585,1.585,0,0,1,1.185-.154,1.544,1.544,0,0,1,1.108,1.858l.477-1.76a1.559,1.559,0,0,1,3.014.8l-.645,2.391a1.559,1.559,0,0,1,3.014.8Z",
    transform: "translate(-246.329 -5.764)",
    fill: "#73c9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_97-2",
    "data-name": "Pfad 97",
    d: "M14.125,10.92a1.544,1.544,0,0,1,1.108-1.858,1.585,1.585,0,0,1,1.185.154,1.511,1.511,0,0,1,.729.939L20.132,21.19c-.028-1.3.981-4.74,2.489-5.139a1.068,1.068,0,0,1,1.528.876c.217.792-.764,2.783-.589,5.272.084,1.283.68,3.575.5,5.139-.112,1.009-1.381,3.245-.946,4.851.266,1,1.823,4.353,1.823,4.353a9.644,9.644,0,0,1-5.244,3.309,8.991,8.991,0,0,1-6.2-.274,44.977,44.977,0,0,0-.855-5.531,12.8,12.8,0,0,0-2.306-3.772,7.4,7.4,0,0,1-1.388-2.713L6.062,16.928a1.533,1.533,0,0,1,1.1-1.886A1.555,1.555,0,0,1,9.07,16.129l-.806-2.98a1.559,1.559,0,0,1,3.014-.8l-.645-2.391a1.556,1.556,0,0,1,.154-1.171,1.571,1.571,0,0,1,2.86.372Z",
    transform: "translate(-5.482 -5.764)",
    fill: "#73c9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_162",
    "data-name": "Pfad 162",
    d: "M6.563,2.321a.433.433,0,0,1-.174-.037A17.028,17.028,0,0,0,.413.87.435.435,0,0,1,.458,0a17.9,17.9,0,0,1,6.28,1.486.435.435,0,0,1-.175.834",
    transform: "translate(33.052 18.691) rotate(20)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_163",
    "data-name": "Pfad 163",
    d: "M.435,2.777a.435.435,0,0,1-.022-.87A10.286,10.286,0,0,0,5.778.078a.435.435,0,0,1,.5.714A11.156,11.156,0,0,1,.457,2.777H.435",
    transform: "translate(32.143 22.505) rotate(20)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_98",
    "data-name": "Pfad 98",
    d: "M283.69,10.027a2.1,2.1,0,0,0-2.334-.971l.336-1.241a2.067,2.067,0,0,0-1.478-2.538,2.081,2.081,0,0,0-1.065-.007l.174-.647a2.069,2.069,0,0,0-.2-1.567l-.006-.011a2.1,2.1,0,0,0-3.819.505l-.017.063a2.07,2.07,0,0,0-.926-.532,2.121,2.121,0,0,0-1.575.2,2.025,2.025,0,0,0-.98,1.261l-2.388,8.823c-.082-.258-.173-.512-.273-.756-.41-1.006-1.12-2.264-2.173-2.543a1.578,1.578,0,0,0-2.169,1.246,4.211,4.211,0,0,0,.184,1.851,11.887,11.887,0,0,1,.387,3.525c-.027.42-.117.98-.212,1.574a14.512,14.512,0,0,0-.283,3.657,7.446,7.446,0,0,0,.411,1.445,6.2,6.2,0,0,1,.55,3.212c-.209.78-1.364,3.345-1.792,4.268a.526.526,0,0,0,.058.539,10.19,10.19,0,0,0,5.528,3.5,11.788,11.788,0,0,0,3.024.431,8.844,8.844,0,0,0,3.52-.729.526.526,0,0,0,.318-.435,44.715,44.715,0,0,1,.84-5.445,11.7,11.7,0,0,1,2.208-3.577,7.973,7.973,0,0,0,1.486-2.906l2.874-10.633a2.035,2.035,0,0,0-.2-1.567m-.812,1.291L280,21.954a6.916,6.916,0,0,1-1.29,2.52,12.4,12.4,0,0,0-2.4,3.964,41.614,41.614,0,0,0-.839,5.3,8.529,8.529,0,0,1-5.577.134A9.292,9.292,0,0,1,265.126,31a44.512,44.512,0,0,0,1.718-4.142,6.89,6.89,0,0,0-.573-3.832,7.153,7.153,0,0,1-.359-1.217,13.834,13.834,0,0,1,.277-3.372c.1-.618.193-1.2.223-1.669a12.953,12.953,0,0,0-.41-3.826,4.56,4.56,0,0,1-.2-1.344c.147-.535.281-.667.886-.507,1.112.294,2.1,3.266,2.1,4.561l-.465,1.719a.526.526,0,1,0,1.015.275L272.81,4.817a.986.986,0,0,1,.48-.616,1.063,1.063,0,0,1,.789-.1,1.021,1.021,0,0,1,.733,1.223v.007c0,.006,0,.012,0,.018l0,.017-2.176,8.031a.526.526,0,0,0,1.015.275l2.181-8.048c0-.011.006-.023.008-.034l.475-1.759a1.033,1.033,0,0,1,2,.523l-.645,2.39-2.019,7.453a.526.526,0,1,0,1.015.275l2.019-7.453v0a1,1,0,0,1,.471-.616,1.034,1.034,0,0,1,.8-.1,1.021,1.021,0,0,1,.631.478,1,1,0,0,1,.1.769L278.658,15a.526.526,0,1,0,1.015.275l1.212-4.476,0-.006a1,1,0,0,1,.472-.61,1.034,1.034,0,0,1,.794-.1,1.014,1.014,0,0,1,.627.475.992.992,0,0,1,.1.765",
    transform: "translate(-240.854 -0.291)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_164",
    "data-name": "Pfad 164",
    d: "M6.563,0a.433.433,0,0,0-.174.037A17.028,17.028,0,0,1,.413,1.451a.435.435,0,0,0,.045.869A17.9,17.9,0,0,0,6.738.834.435.435,0,0,0,6.563,0",
    transform: "matrix(-0.966, 0.259, -0.259, -0.966, 10.818, 20.926)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_165",
    "data-name": "Pfad 165",
    d: "M.435,0A.435.435,0,0,0,.413.87,10.286,10.286,0,0,1,5.778,2.7a.435.435,0,0,0,.5-.714A11.156,11.156,0,0,0,.457,0H.435",
    transform: "matrix(-0.966, 0.259, -0.259, -0.966, 11.509, 25.246)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_99",
    "data-name": "Pfad 99",
    d: "M18.137,26.576a6.2,6.2,0,0,1,.55-3.211,7.453,7.453,0,0,0,.411-1.442,14.506,14.506,0,0,0-.283-3.66c-.095-.594-.185-1.154-.212-1.577a11.885,11.885,0,0,1,.388-3.523,4.211,4.211,0,0,0,.184-1.851A1.578,1.578,0,0,0,17,10.067c-1.053.279-1.762,1.536-2.173,2.542-.1.243-.19.5-.273.756l-2.387-8.82a2.025,2.025,0,0,0-.978-1.263,2.125,2.125,0,0,0-1.58-.2,2.065,2.065,0,0,0-.924.531l-.017-.064a2.1,2.1,0,0,0-3.818-.5l-.006.011a2.069,2.069,0,0,0-.2,1.568l.174.646a2.11,2.11,0,0,0-2.337.974A2.043,2.043,0,0,0,2.274,7.81L2.61,9.051a2.063,2.063,0,0,0-1.062,0,2.058,2.058,0,0,0-1.272.967,2.034,2.034,0,0,0-.2,1.565L2.947,22.223a7.975,7.975,0,0,0,1.486,2.906,11.7,11.7,0,0,1,2.208,3.579,44.721,44.721,0,0,1,.839,5.443.526.526,0,0,0,.319.435,8.84,8.84,0,0,0,3.519.729,11.8,11.8,0,0,0,3.026-.431,10.189,10.189,0,0,0,5.527-3.5.526.526,0,0,0,.058-.539c-.428-.922-1.583-3.487-1.792-4.269m-4.063,7.291A8.531,8.531,0,0,1,8.5,33.733a41.619,41.619,0,0,0-.839-5.3,12.393,12.393,0,0,0-2.405-3.966,6.916,6.916,0,0,1-1.29-2.52L1.088,11.312a.991.991,0,0,1,.1-.763,1.017,1.017,0,0,1,.632-.477,1.031,1.031,0,0,1,.79.1,1,1,0,0,1,.472.61l0,.006,1.211,4.476a.526.526,0,0,0,1.015-.275L3.289,7.535a1,1,0,0,1,.1-.768,1.054,1.054,0,0,1,1.427-.376,1,1,0,0,1,.471.616v0l2.019,7.453a.526.526,0,0,0,1.015-.275L6.3,6.736l-.645-2.39a1.034,1.034,0,0,1,2-.525L8.13,5.564l0,.017c0,.012,0,.023.008.034l2.181,8.048a.526.526,0,0,0,1.015-.275L9.161,5.357l0-.017c0-.006,0-.012,0-.018V5.316a1.02,1.02,0,0,1,.732-1.222,1.066,1.066,0,0,1,.794.1.986.986,0,0,1,.478.617l3.47,12.822a.526.526,0,0,0,1.015-.275l-.465-1.719c0-1.295.985-4.267,2.1-4.561.606-.16.74-.028.887.507a4.564,4.564,0,0,1-.2,1.344,12.942,12.942,0,0,0-.41,3.824c.031.468.124,1.053.223,1.671a13.83,13.83,0,0,1,.277,3.375,7.176,7.176,0,0,1-.359,1.215,6.891,6.891,0,0,0-.573,3.831,44.534,44.534,0,0,0,1.718,4.143,9.29,9.29,0,0,1-4.766,2.875",
    transform: "translate(0 -0.287)",
    fill: "#303e58"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1Grafik);
export default __webpack_public_path__ + "static/media/step-1-grafik.c44089f03aa737a2d9aa8561215bacd9.svg";
export { ForwardRef as ReactComponent };